import React, { useState } from 'react';
import { StyleSheet, View, Text, TouchableOpacity, ScrollView } from 'react-native';
import { getWordBankList } from '../data/wordBanks/wordBanks';

type Props = {
  onSelect: (settings: {
    wordBankId: string;
  }) => void;
};

export default function WordBankSelector({ onSelect }: Props) {
  const [selectedBankId, setSelectedBankId] = useState<string | null>(null);
  const wordBanks = getWordBankList();

  const handleConfirm = () => {
    if (selectedBankId) {
      onSelect({
        wordBankId: selectedBankId,
      });
    }
  };

  return (
    <ScrollView style={styles.container}>
      <Text style={styles.title}>Select Word Bank</Text>
      
      <View style={styles.bankList}>
        {wordBanks.map(bank => (
          <TouchableOpacity
            key={bank.id}
            style={[
              styles.bankCard,
              selectedBankId === bank.id && styles.selectedCard
            ]}
            onPress={() => {
              setSelectedBankId(bank.id);
              onSelect({ wordBankId: bank.id });
            }}
          >
            <Text style={styles.bankName}>{bank.name}</Text>
            <Text style={styles.bankDescription}>{bank.description}</Text>
            <Text style={styles.bankStats}>
              {bank.wordCount} words • {bank.categories.length} categories
            </Text>
          </TouchableOpacity>
        ))}
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#1E4B8F',
    marginBottom: 20,
  },
  bankList: {
    gap: 15,
    marginBottom: 20,
  },
  bankCard: {
    backgroundColor: '#fff',
    padding: 15,
    borderRadius: 12,
    borderWidth: 2,
    borderColor: '#ddd',
  },
  selectedCard: {
    borderColor: '#E63946',
    backgroundColor: '#fff3e0',
  },
  bankName: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#1E4B8F',
    marginBottom: 5,
  },
  bankDescription: {
    fontSize: 14,
    color: '#666',
    marginBottom: 10,
  },
  bankStats: {
    fontSize: 12,
    color: '#999',
  },
}); 